<template>
  <div>
    <button type="button" class="generic-button" @click="backClick">
      <span class="button__text" v-if="front === true">{{ title }}</span>
      <span class="button__icon">
        <ion-icon :name="icon"></ion-icon>
      </span>
      <span class="button__text" v-if="front === false">{{ title }}</span>
    </button>
  </div>
</template>

<script>
import router from "../../router";

export default {
  props: {
    returnUrl: { type: String },
    title: { type: String },
    icon: { type: String },
    front: { type: Boolean, default: true },
  },

  components: {},

  name: "genericButton",

  data() {
    return {};
  },

  computed: {},

  methods: {
    backClick() {
      if (this.returnUrl != "") {
        router.replace(this.returnUrl);
      } else {
        this.$router.go(-1);
      }
    },
  },
  async mounted() {},
};
</script>